import React from 'react';
import { Table } from 'reactstrap';
import { formatTime } from 'utils/fuctions/formatDateTime';

const thStyle = {
  whiteSpace: 'break-spaces',
  textAlign: 'center'
};

/**
 * Component to render a table displaying the last dialers.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.data - The data to be displayed in the table.
 * @param {Object} props.data[].numero - The number of the dialer.
 * @param {Object} props.data[].discagem - The time of the dial.
 *
 * @returns {JSX.Element} The rendered table component.
 */

const LastDialersTable = ({ data }) => {
  return (
    <Table className="mb-5 overflow-y-visible" bordered={true} striped>
      <thead>
        <tr>
          <th style={thStyle}>Número</th>
          <th style={thStyle}>Discagem</th>
        </tr>
      </thead>
      <tbody>
        {data &&
          data.map((row, i) => {
            return (
              <tr key={i}>
                <td>{row.numero}</td>
                <td>{formatTime(row.discagem)}</td>
              </tr>
            );
          })}
      </tbody>
    </Table>
  );
};

export default LastDialersTable;
